import { InsertConciliacionBancariaCommandProps } from "api/Commands/InsertConciliacionBancariaCommand"
import { postConciliacionBancariaManual } from "api/ConciliacionBancaria.service"
import { useCallback } from "react"
import { useHistory, useLocation, useParams } from "react-router-dom"
import { BodyToMethodConciliacionProps } from "../interfaces/ip-propuestas-conciliacion-page"

export const usePropuestasConciliacionPage = () => {
  const { cuentaId } = useParams<{ cuentaId: string }>()
  const history = useHistory()
  const location = useLocation()
  const searchParams = new URLSearchParams(location.search)
  const ibanCuenta = searchParams.get("iban") || ""
  const nifTitular = searchParams.get("nifTitular") || ""
  const handleConciliar = useCallback(
    async (body: BodyToMethodConciliacionProps) => {
      const bodyToMethod: InsertConciliacionBancariaCommandProps = {
        cuentaBancariaId: cuentaId ?? "",
        movimientoBancarioIdsExternos: [body.movimientoBancarioIdsExternos],
        ...(body.facturaIds.length && { facturaIds: body.facturaIds }),
        ...(body.flujoTesoreriaIds.length && {
          flujoTesoreriaIds: body.flujoTesoreriaIds,
        }),
      }
      const res = await postConciliacionBancariaManual(bodyToMethod)
      return !!res
    },
    [cuentaId]
  )

  const handleBack = useCallback(() => {
    history.goBack()
  }, [history])

  return {
    cuentaId,
    ibanCuenta,
    nifTitular,
    handleConciliar,
    handleBack,
  }
}
